<template>
  <div class="cmp-wrapper">
    <basic-container>
      <el-form inline :model="formData" ref="subjectBillManage">
       
        <el-form-item label="分润主体名称" prop="subjectId" style="margin-left:10px;">
          <fuzzy-query
            ref="cusOption2"
            :valueId.sync="subjectId"
            typeKey="subjectName"
            :option="cusOption2"
          ></fuzzy-query>
        </el-form-item>

        <el-form-item label="账单号">
          <el-input style="margin-left:10px;" v-model="formData.billId" placeholder="请输入账单号"/>
        </el-form-item>

        <el-form-item label="状态">
          <el-select style="margin-left:10px;" v-model="formData.status" @change="selectStatus" placeholder="请选择">
            <el-option label="待提交" value="0"></el-option>
            <el-option label="待商家确认" value="3"></el-option>
            <el-option label="待付款" value="12"></el-option>
            <el-option label="商家打回" value="18"></el-option>
            <el-option label="已完成" value="30"></el-option>
            <el-option label="全部" value=""></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="账单类型">
          <el-select style="margin-left:10px;" v-model="formData.billType" @change="selectStatus" placeholder="请选择">
            <el-option label="普通账单" value="1"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="账单日期">
          <el-date-picker
            v-model="createTime"
            type="daterange"
            value-format="timestamp"
            :default-time="['00:00:00', '23:59:59']"
            style="margin-left:10px;width:500px;"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
          <!-- <el-button @click="reset">重置</el-button> -->
        </el-form-item>
        <el-form-item style="width:20%">
          <el-button type="success" @click="exportFile" size="small">导出报表</el-button>
        </el-form-item>
        <el-form-item style="width:20%">
          <el-button type="success" @click="exportRecord" size="small">明细报表导出</el-button>
        </el-form-item>
        <el-form-item v-if="showBatch" style="margin-left: 5px;">
          <el-button type="primary" @click="confirmBatchBill" size="small">确认账单并结算</el-button>
        </el-form-item>
        <div v-if="selectedBillTotalAmount > 0" style="width: 100%;">
          已勾选账单总金额: <span style="font-size: 20px; color: red"> {{selectedBillTotalAmount.toFixed(2)}}元</span>
      </div>
      </el-form>


      <el-table v-loading="loading" :data="tableData" @selection-change="handleSelectionChange">
        <el-table-column v-if="showBatch" type="selection" align="center" width="55px"></el-table-column>
        <el-table-column label="账单号" align="center" width="150px" prop="id"></el-table-column>
        <el-table-column label="分润主体" align="center" width="150px" prop="accountName"></el-table-column>
        <el-table-column label="账单日期" align="center" width="150px" prop="billPeriod"></el-table-column>
        <el-table-column label="申请日期" align="center" width="100px" prop="createDateStr"></el-table-column>
        <el-table-column label="申请人" align="center" width="120px" prop="createUserName"></el-table-column>
        <el-table-column label="完成日期" align="center" width="100px" prop="compileTimeStr"></el-table-column>
        <el-table-column label="平台应付" align="center" width="120px" prop="sendAmount"></el-table-column>
        <el-table-column label="平台应收" align="center" width="120px" prop="receiveAmount"></el-table-column>
        <el-table-column label="请款金额" align="center" width="120px" prop="requireAmount"></el-table-column>
        <el-table-column label="状态" align="center" width="120px" prop="statusStr"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button class="operateBtn" type="text" @click="toDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="footer pager">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="formData.pageNumber"
          :page-size.sync="formData.pageSize"
          :page-sizes="[20, 30, 40, 50]"
          layout="total, sizes, prev, pager, next, jumper"
          :total.sync="total"
          background
        ></el-pagination>
      </div>
    </basic-container>
  </div>
</template>
<script>
import {dateTimeFormatter} from '@/utils/utils.js'
import { getBaseUrl,exportFile } from "@/framework/utils/tools";

export default {
  data() {
    return {
      selectStore:'1',
      subjectId:"",
      createTime:[],
      cusOption2:[],
      selectBills:[],
      formData: {
        subjectId: "",
        billId: "",
        billType: "",
        status: "",
        startTime: "",
        endTime: "",
        pageNumber: 1,
        pageSize: 20,
        fromSource: "cs"
      },
      total: 0,
      loading: false,
      showBatch: false,
      tableData: [],
      selectedBillTotalAmount: 0,
      pickerOptions: {
          disabledDate(time) {
            let cur_time = new Date(new Date().toLocaleDateString()).getTime();
            return time.getTime() > cur_time + 86400000 - 1000;
          },
        },
    };
  },
  created() {
    
  },

  beforeRouteEnter(to, from, next) {
    next(async vm => {
      try {
        if(vm.$route.query.subjectId) {
          vm.subjectId = vm.$route.query.subjectId;
          vm.formData.subjectId = vm.$route.query.subjectId;
          vm.showBatch = true;
        }
        if(vm.$route.query.status) {
          vm.formData.status = vm.$route.query.status;
        }
        vm.search();
      } catch (error) {
        console.log(error);
        next();
      }
      
    })
  },

  beforeRouteLeave(to, from, next) {
    this.$refs.subjectBillManage.resetFields(); 
    this.subjectId="";
    this.formData.subjectId="";
    this.showBatch=false;
    this.selectedBillTotalAmount=0;
    this.status="";
    this.$destroy();
    next();
  },


  watch: {
    "createTime": {
      handler: function(val) {
        if (val) {
          const [start_time, end_time] = val;
          Object.assign(this.formData, { startTime: start_time/1000, endTime: end_time/1000 });
        }else {
          Object.assign(this.formData, { startTime: "", endTime: "" });
        }
      }
    },
    "subjectId":{
      handler: function(val) {
        this.formData.subjectId = val
      }
    }
  },
  methods: {
    toDetail(row){
      if(row){
        this.$router.push({
          path: "/splitAccountManage/billDetail",
          query: {
            billId:row.id
          }
        });
      }
    },
    _formatDate (ct) {
      return ct ? dateTimeFormatter(ct*1000, 'YYYY-MM-DD HH:mm:ss') : '--'
    },
    handleClick(tab, event) {
      this.search()
    },
    handleSelectionChange(bills) {
      this.selectBills = bills.map(bill => {
        return {billId: bill['id'], requireAmount: bill['requireAmount']}
      })
      
      if(this.selectBills && this.selectBills.length > 0) {
        this.selectedBillTotalAmount = 0;
        for(let i=0; i<this.selectBills.length; i++){
          let item = this.selectBills[i]
          if(item['requireAmount'] && item['requireAmount'] != '') {
            this.selectedBillTotalAmount+=item['requireAmount'];
          }
        }
      }
    },
    confirmBatchBill() {
      if(this.selectBills && this.selectBills.length > 0) {
        var title = "本次合计结算" + this.selectBills.length + "个账单, 合计结算" + this.selectedBillTotalAmount;
        this.$confirm(title, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(async () => {
          var billIds = this.selectBills.map(n => n.billId);
          this.batchReviewBill(billIds);
        });
      } else {
        this.$message({
          type: "warning",
          message: "请勾选需要结算的账单"
        });
        return;
      }
    },
    search() {
      this.formData.pageNumber = 1;
      this.selectedBillTotalAmount = 0;
      this.getList();
    },
    async getList() {
      this.loading = true;
      try {
        const {
          ret,
          data
        } = await _api.splitAcc.getBillList(this.formData);
        if (ret && data) {
          this.tableData = data.data || [];
          this.total = data.total;
        }
      } catch (error) {
        console.log(error);
      }
      this.loading = false;
    },
    async batchReviewBill(ids) {
      if(ids && ids.length > 0) {
        try {
          const {
            ret,
            data,
            error
          } = await _api.splitAcc.batchReviewBill({
            billIds:ids,
            isPass:true
          });
        if (ret) {
          this.$message({
            type: "success",
            message: "批量确认成功"
          });
        } else {
          this.$message({
            type: "error",
            message: error.msg
          });
        }
        this.search();
      } catch (error) {
        console.log(error);
      }
      }
    },
    // 重置
    reset() {
      this.formData.storeId = ""
      if(this.$refs["cusOption2"]){
        this.$refs["cusOption2"].reset()
      }
      this.$refs["subjectBillManage"].resetFields();
      this.createTime = []
    },
    handleCurrentChange(val) {
      this.formData.pageNumber=val;
      this.getList();
    },
    handleSizeChange(val) {
      this.formData.pageSize=val;
      this.formData.pageNumber = 1;
      this.getList();
    },
    //导出
    async exportFile() {
      this.loading=true;
      const {
        ret,
        data
      } = await _api.splitAcc.billExport(this.formData);
        
      this.loading=false;

      if(ret && data){
        try {
          const downloadUrl = data;
          const link = document.createElement('a');
          link.href = downloadUrl;
          link.download = '账单数据.xlsx';
          link.target = '_blank'; //在新标签页中下载
          link.click();
        } catch (error) {
          console.error('下载文件出错', error);
        }
      }

      //exportFile(`${getBaseUrl()}/dmall-manage/dmallmanage/order/export`,this.formData,'订单数据.xlsx')
    },
    //导出明细
    async exportRecord() {
      this.loading = true;
      try {
        let param={
          "subjectId":this.formData.subjectId,
          "startTime":this.formData.startTime,
          "endTime":this.formData.endTime,
          "sourceType":1
        }
        if(param.subjectId==null|| param.subjectId === ""){
          this.$message.warning("请选择分润主体");
          return
        }
        if(param.startTime==null|| param.startTime === ""
            ||param.endTime==null|| param.endTime === ""){
          this.$message.warning("请选择起止时间");
          return
        }
        const {
          ret,
          data
        } = await _api.splitAcc.billRecordExport(param);
        if (ret && data) {
          const downloadUrl = data;
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.download = "下单流水明细.xlsx";
          link.target = "_blank"; //在新标签页中下载
          link.click();
        }
      } catch (error) {
        console.error("下载文件出错", error);
      }

      this.loading = false;

      //exportFile(`${getBaseUrl()}/dmall-manage/dmallmanage/order/export`,this.formData,'订单数据.xlsx')
    },
  }
};
</script>
<style>
.img li{ 
  float:left;
  margin-left:5px; 
  list-style-type:none;
}
</style>